module.exports = __webpack_public_path__ + "static/media/Mar19-S18.f1588382.png";